import { useMemo } from "react";
import { useParams } from "react-router";
import { useCampaignInquiry } from "src/hooks/campaignInquiries";
import { mapInquiry } from "src/utils/mapping/mapToInput";

import { CampaignInquiryDuplicationTemplate } from "./CampaignInquiryDuplicationTemplate";

const CampaignInquiryDuplicationInquiryPage = () => {
    const { campaignInquiryId } = useParams();
    const { campaignInquiry, isLoadingCampaignInquiry } = useCampaignInquiry(campaignInquiryId);

    const initialValues = useMemo(() => {
        return campaignInquiry ? mapInquiry(campaignInquiry) : undefined;
    }, [campaignInquiry]);

    return (
        <CampaignInquiryDuplicationTemplate
            key={campaignInquiry?.id}
            initialValues={initialValues}
            isLoading={isLoadingCampaignInquiry}
        />
    );
};

export default CampaignInquiryDuplicationInquiryPage;
